import { windowsVariant } from './_windows';
import { macVariant } from './_mac';
import { androidVariant } from './_android';
import { iosVariant } from './_ios';
import { IndexPageVariant } from '../models/indexPageVariant';

export const PLATFORMS: IndexPageVariant[] = [windowsVariant, macVariant, androidVariant, iosVariant];
